import { applicationTypeEnum } from "../../../../../Helpers/EnumHelper";
import { Col, Row } from "react-bootstrap";
import IconSvg from "../../../../SharedComponents/IconSvg";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import { SetStartInfoModalIsShown } from "../../Store";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const AppCardFooter = ({ application, company, ticketId, setSelectedAssessment, isMobile }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [footerContent, setFooterContent] = useState({ buttonIsShown: false, text: "" });

  const HandleStart = (application, ticketId) => {
    if (applicationTypeEnum.Inventory === application.applicationType) {
      navigate("/invapp/" + application.id + "/" + ticketId, {
        state: { clickCounter: application.sessionsData?.clickCounter },
      });
      dispatch(SetStartInfoModalIsShown(false));
    }
  };

  useEffect(() => {
    setFooterContent(CheckSessionState(application));
  }, [application]);

  const isPastDeadline = (deadline) => {
    const deadlineDate = new Date(deadline);
    if (isNaN(deadlineDate.getTime())) throw new Error("Invalid date format");
    return deadlineDate < new Date();
  };

  const HandleRemainingDuration = (application) => {
    // Duration is now stored as seconds, convert to minutes for display
    if (application.sessionsData === null) return Math.floor(application.duration / 60);
    else if (application.sessionsData?.remainingDuration)
      return Math.floor(application.sessionsData.remainingDuration / 60);
    else console.log("ERROR AT HandleRemainingDuration. its in AppCardFooter.js");
  };

  const HandleWrapUpButton = (application) => {
    const path = application.applicationType === applicationTypeEnum.Inventory ? "/iresult/" : "/tresult/";
    navigate(path + application.sessionsData.resultId, { state: { backUrl: "/myResults/" } });
  };

  const HandleCardButtonClick = (company, application, ticketId) => {
    // Block mobile users from starting assessments
    if (isMobile) {
      return;
    }

    if (application.sessionsData?.resultId && application.sessionsData.isFinished && application?.allowPdf) {
      HandleWrapUpButton(application);
    } else if (company.hasDemography) {
      if (applicationTypeEnum.Inventory === application.applicationType) HandleStart(application, ticketId);
      else {
        dispatch(SetStartInfoModalIsShown(true));
        setSelectedAssessment({ application, company, ticketId });
      }
    } else {
      navigate("/demographyForm", {
        state: { company, application, ticketId, candidateId: company.candidateId },
      });
    }
  };

  const CheckSessionState = (application) => {
    const sessionsData = application.sessionsData;

    // Check for mobile device first - but allow viewing results
    if (isMobile && !(sessionsData?.isFinished && application?.allowPdf && sessionsData?.resultId)) {
      return { buttonIsShown: false, text: "footer.usePcToStart" };
    }

    if (sessionsData?.clickCounter >= 5 && !sessionsData?.isFinished)
      return { buttonIsShown: false, text: "footer.noLoginAttemptsLeft" };
    if (application.sessionsData?.isFinished) {
      if (application.allowPdf && application.sessionsData?.resultId)
        return { buttonIsShown: true, text: "footer.goToResult" };
      return { buttonIsShown: false, text: "footer.completed" };
    }
    if (isPastDeadline(application.deadline)) return { buttonIsShown: false, text: "footer.deadlinePassed" };
    if (application.sessionsData?.remainingDuration <= 0 && application.applicationType === 0)
      return { buttonIsShown: false, text: "footer.timeout" };
    if (sessionsData) return { buttonIsShown: true, text: "footer.continue" };
    return {
      buttonIsShown: true,
      text: company.hasDemography ? "footer.start" : "footer.fillDemography",
    };
  };

  return (
    <Row className="mt-auto justify-content-between">
      <Col>
        <Row style={{ height: "54px" }}>
          <Col className="align-content-end">
            <Row className="justify-content-between text-12">
              {application.preventCheating &&
                !application.sessionsData?.isFinished &&
                application.applicationType === applicationTypeEnum.Test && (
                  <Col xs="auto" className="mb-2">
                    <Row>
                      <Col xs="auto" className="pe-0 align-content-start">
                        <IconSvg icon="warning-black-outline" width={18} height={16} />
                      </Col>
                      <Col xs="auto" className="text-12 text-color-gray-light fw-medium ps-1 align-content-end">
                        {t("footer.cheatingProtection")}
                      </Col>
                    </Row>
                  </Col>
                )}
            </Row>
            <Row className="justify-content-between text-12">
              {application?.openCam && application.applicationType === 0 && (
                <Col xs="auto" className="mb-2">
                  <Row>
                    <Col xs="auto" className="pe-0 align-content-start">
                      <IconSvg icon="webcamEnabled" width={18} height={18} />
                    </Col>
                    <Col xs="auto" className="text-12 text-color-gray-light fw-medium ps-1 align-content-end">
                      {t("footer.cameraRequired")}
                    </Col>
                  </Row>
                </Col>
              )}
              {application.sessionsData?.clickCounter &&
                application.sessionsData?.clickCounter !== 5 &&
                !application.sessionsData?.isFinished && (
                  <Col xs="auto" className="mb-2">
                    <Row>
                      <Col xs="auto" className="pe-0 text-color-gray-light fw-medium">
                        {t("footer.remainingLoginAttempts")}:
                      </Col>
                      <Col xs="auto" className="text-color-gray-dark fw-semibold">
                        {5 - application.sessionsData?.clickCounter}
                      </Col>
                    </Row>
                  </Col>
                )}
            </Row>
          </Col>
        </Row>
        <Row className="justify-content-between ">
          {application.applicationType === applicationTypeEnum.Test && !application.sessionsData?.isFinished && (
            <Col xs="auto" className="align-content-center">
              <Row>
                <Col className="align-content-center" xs="auto">
                  <IconSvg icon="clock" />
                </Col>
                <Col className="px-0 align-content-center">
                  {HandleRemainingDuration(application)} {t("minutes")}
                </Col>
              </Row>
            </Col>
          )}
          <Col className="align-content-center">
            <Row className="justify-content-center" style={{ height: "40px" }}>
              {footerContent.buttonIsShown ? (
                <Col className="align-content-center">
                  <Button
                    className="button secondary w-100"
                    style={{ borderRadius: "10px" }}
                    onClick={() => HandleCardButtonClick(company, application, ticketId)}
                  >
                    {t(footerContent.text)}
                  </Button>
                </Col>
              ) : (
                <Col xs="auto" className="align-content-center text-color-gray-dark fw-semibold">
                  {t(footerContent.text)}
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AppCardFooter;
